import { yupResolver } from '@hookform/resolvers/yup'
import { useResourceContext } from 'ra-core'
import React from 'react'
import UpsellingHintInput from 'resources/catalog/food/upselling/UpsellingHintInput'
import {
  APIEntity,
  ProductWithUpsellingEntity,
  UpsellingEntity,
} from 'services/api/entities'
import { useKGetList } from 'services/hooks/useKGetList'
import { upsellingVSBuilder } from 'services/validations/catalog/upselling'
import StandardPricingInput from 'ui-shared/FormComponents/pricing/standard/StandardPricingInput'
import LocalizedAutoCompleteArrayInput from 'ui-shared/LocalizedFields/LocalizedAutoCompleteArrayInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import { CatalogItemBaseFormProps } from './CatalogItemBaseForm'
import ProductForm from './ProductForm'

type Props = CatalogItemBaseFormProps & {
  relatedProduct: Extract<APIEntity, ProductWithUpsellingEntity>
}

const UpsellingForm: React.FC<Props> = ({
  children,
  relatedProduct,
  resolver,
  ...props
}) => {
  const defaultResolver = yupResolver(
    upsellingVSBuilder(useResourceContext() as UpsellingEntity)
  )

  return (
    <ProductForm resolver={resolver ?? defaultResolver} {...props}>
      <KNumberInput
        source="minQuantity"
        label="Minimum quantity"
        defaultValue={1}
      />

      <LocalizedAutoCompleteArrayInput
        source="products"
        choices={useKGetList(relatedProduct)}
        fullWidth
        label="form.fields.products"
      />
      {children}
      <UpsellingHintInput />
      <StandardPricingInput />
    </ProductForm>
  )
}

export default UpsellingForm
